import { useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Plus, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import JobCard from '@/components/jobs/JobCard';
import { useJobs } from '@/hooks/useJobs';

export default function JobsPage() {
  const { jobs, loading, error, listJobs, deleteJob } = useJobs();

  useEffect(() => {
    listJobs();
  }, [listJobs]);

  const handleDelete = useCallback(
    async (jobId: string) => {
      try {
        await deleteJob(jobId);
      } catch (err) {
        console.error('Failed to delete:', err);
      }
    },
    [deleteJob],
  );

  return (
    <div className="max-w-3xl mx-auto space-y-6 p-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">Analysis Jobs</h1>
        <Button asChild>
          <Link to="/">
            <Plus className="h-4 w-4 mr-2" />
            New Analysis
          </Link>
        </Button>
      </div>

      {loading && (
        <div className="flex justify-center py-12">
          <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
        </div>
      )}

      {error && (
        <div className="p-4 bg-destructive/10 border border-destructive/20 rounded-lg">
          <p className="text-sm text-destructive">{error}</p>
        </div>
      )}

      {!loading && jobs.length === 0 && (
        <div className="text-center py-12 space-y-3">
          <p className="text-muted-foreground">No analysis jobs yet.</p>
          <Button asChild>
            <Link to="/">Start your first analysis</Link>
          </Button>
        </div>
      )}

      <div className="space-y-3">
        {jobs.map((job) => (
          <JobCard key={job.id} job={job} onDelete={handleDelete} />
        ))}
      </div>
    </div>
  );
}
